var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"+"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("polygon",{"id":"+","fill":"#1D355B","transform":"translate(6.904143, 6.904143) rotate(-315.000000) translate(-6.904143, -6.904143) ","points":"6.02914266 15.2691427 6.02914266 7.74414266 -1.56585734 7.74414266 -1.56585734 6.06414266 6.02914266 6.06414266 6.02914266 -1.46085734 7.77914266 -1.46085734 7.77914266 6.06414266 15.3741427 6.06414266 15.3741427 7.74414266 7.77914266 7.74414266 7.77914266 15.2691427"}))]);
}

CloseInline.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
